exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.featured-outfit-card-container {\n  margin: 24px 3vw;\n  height: 530px;\n}\n.footer-buttons {\n  background-color: white;\n  flex-basis: 80px;\n  padding: 20px 0;\n  border-radius: 0 0px 20px 20px;\n  display: flex;\n  justify-content: space-evenly;\n}\n.footer-buttons .footer-button {\n  border-radius: 23px;\n  padding: 0px 13px;\n  height: 46px;\n  font-family: \"Lato\";\n  font-size: 14px;\n  background-color: #efefef;\n  flex: 0.45;\n}\n.footer-buttons .footer-button--pink {\n  background-color: #f2c0de;\n  color: white;\n}\n.save-button-container {\n  margin-top: 30px;\n}", ""]);

// exports
